import { m as motion } from 'framer-motion';
import { Inline, RichTextContent, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const perkWrapperStyles = css`
  margin-top: 16px;
  overflow: hidden;
`;
const perkTextWrapperStyles = css`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const richTextStyles = css`
  ul {
    list-style: none;
    margin-inline-start: 0;
    padding-inline-start: 0;

    li {
      padding-inline-start: 24px;
      position: relative;
      &::before {
        background-color: ${vars.colors.signal.positive.foreground};
        content: '';
        height: 16px;
        inset-inline-start: 0;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath d='M128%2C24A104%2C104%2C0%2C1%2C0%2C232%2C128%2C104.11%2C104.11%2C0%2C0%2C0%2C128%2C24Zm45.66%2C85.66-56%2C56a8%2C8%2C0%2C0%2C1-11.32%2C0l-24-24a8%2C8%2C0%2C0%2C1%2C11.32-11.32L112%2C148.69l50.34-50.35a8%2C8%2C0%2C0%2C1%2C11.32%2C11.32Z'/%3E%3C/svg%3E");
        mask-repeat: no-repeat;
        mask-size: contain;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
      }
    }
  }
`;
const CabinUpgradePerks = ({
  ariaLabel,
  availablePerks,
  segmentKey
}) => /*#__PURE__*/_jsx(motion.div, {
  animate: "open",
  "aria-label": ariaLabel,
  className: perkWrapperStyles,
  initial: "collapsed",
  role: "list",
  transition: {
    duration: 0.4,
    ease: [0.25, 0.1, 0.25, 1]
  },
  variants: {
    open: {
      opacity: 1,
      height: 'auto'
    },
    collapsed: {
      opacity: 0,
      height: 0
    }
  },
  children: availablePerks.map((perk, perkIndex) => /*#__PURE__*/_jsx(Inline, {
    className: perkTextWrapperStyles,
    "data-testid": `${CABIN_UPGRADE.name}-${segmentKey}-perk-${perkIndex}`,
    role: "listitem",
    spacing: 16,
    children: /*#__PURE__*/_jsx(RichTextContent, {
      className: richTextStyles,
      children: perk
    })
  }, `${segmentKey}-perk-${perkIndex}`))
}, `${segmentKey}-motion`);
export default CabinUpgradePerks;
//# sourceMappingURL=CabinUpgradePerks.js.map